/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

export const ProtocolistStatusEventType = "klava.call.protocolist.status";
export const ProtocolistStatusStateKey = "current";

export type ProtocolistStatusEventStatus =
  | "connecting"
  | "connected"
  | "failed"
  | "disconnected";

export interface ProtocolistStatusEventContent {
  version: 1;
  status: ProtocolistStatusEventStatus;
  started_by_user_id?: string;
  started_by_name?: string;
  started_at?: number;
  bot_user_id?: string;
  egress_id?: string;
  connected_at?: number;
  failed_at?: number;
  disconnected_at?: number;
  stopped_by_user_id?: string;
  stopped_by_name?: string;
  error_text?: string;
  protocol_recipient_user_ids?: string[];
}

/**
 * Проверяет, что контент похож на событие статуса протоколиста.
 */
export function isProtocolistStatusEventContent(
  content: unknown,
): content is ProtocolistStatusEventContent {
  if (typeof content !== "object" || content === null) {
    return false;
  }

  const candidate = content as Partial<ProtocolistStatusEventContent>;
  return (
    candidate.version === 1 &&
    (candidate.status === "connecting" ||
      candidate.status === "connected" ||
      candidate.status === "failed" ||
      candidate.status === "disconnected")
  );
}
